import PlaceSearch from "./PlaceSearch";
export default PlaceSearch;
//# sourceMappingURL=index.js.map